import gql from 'graphql-tag';
import {useMemo} from 'react';

import type {
  RunSelectorFieldAggregationsQuery as QueryType,
  RunSelectorFieldAggregationsQueryVariables as VariablesType,
} from '../../../generated/graphql';
import {useQuery} from '../../../state/graphql/apolloWithAbort';
import {propagateErrorsContext} from '../../../util/errors';
import {useRunSelectorProjectInfo} from '../RunSelectorRunSetContext';

export const RUN_SELECTOR_FIELD_AGGREGATIONS = gql`
  query RunSelectorFieldAggregations(
    $projectInternalId: ID!
    $fieldPattern: String!
  ) {
    project(internalId: $projectInternalId) {
      id
      fields(
        pattern: $fieldPattern
        types: ["number"]
        columns: ["summary_metrics", "aggregations_min", "aggregations_max"]
      ) {
        edges {
          node {
            path
          }
        }
      }
    }
  }
`;

export function useFieldHasAggregations(field: string, skip: boolean) {
  const {projectInternalId = ''} = useRunSelectorProjectInfo();

  const response = useQuery<QueryType, VariablesType>(
    RUN_SELECTOR_FIELD_AGGREGATIONS,
    {
      context: propagateErrorsContext(),
      variables: {
        projectInternalId,
        fieldPattern: field,
      },
      skip: !projectInternalId || skip,
    }
  );

  return useMemo(() => {
    if (!response.data) {
      return response;
    }
    const fields =
      response.data.project?.fields?.edges?.map(edge => edge.node.path) ?? [];

    const hasAggregations = fields.some(f =>
      f.match(/^aggregations_(min|max)\./)
    );

    return {
      ...response,
      data: hasAggregations,
    };
  }, [response]);
}
